// src/components/Landing.js
import React from 'react';
import { Link } from 'react-router-dom';
import AreaCard from './AreaCard';
import '../styles/Landing.css';

const areas = [
  {
    title: 'Administrativo',
    summary: 'Contabilidad, finanzas, legal y talento humano con enfoque estratégico, orden y transparencia.',
    details: [
      'Procesos contables, financieros y legales.',
      'Gestión de talento humano.',
      'Funcionamiento empresarial de forma estratégica.',
      'Orden y transparencia como base de gestión.',
    ],
    icon: '',
    bg: '/img/areas/admin.webp',
    bgAlt: 'Equipo administrativo trabajando con reportes',
    bgPosition: '50% 40%',
  },
  {
    title: 'Docente',
    summary: 'Enseñanza lúdica y transformadora que impulsa pensamiento crítico, creatividad y curiosidad tecnológica.',
    details: [
      'Trabajo con niños, adolescentes y adultos.',
      'Fomento del pensamiento crítico.',
      'Creatividad y curiosidad tecnológica.',
      'Metodologías lúdicas y transformadoras.',
    ],
    icon: '',
    bg: '/img/areas/docente.webp',
    bgAlt: 'Docente guiando actividad tecnológica',
  },
  {
    title: 'Producción + ID',
    summary: 'Diseñamos y construimos kits de robótica para la formación tecnológica, con altos estándares de calidad y funcionalidad.',
    details: [
      'Diseño y construcción de kits de robótica.',
      'Apoyo directo a la formación tecnológica de estudiantes.',
      'Altos estándares de calidad.',
      'Enfoque en la funcionalidad.',
    ],
    icon: '',
    bg: '/img/areas/produccion.webp',
    bgAlt: 'Prototipado de kits de robótica',
    bgPosition: 'center top',
  },
  {
    title: 'TIC',
    summary: 'Soluciones digitales que potencian la experiencia educativa y optimizan los procesos internos.',
    details: [
      'Desarrollo de soluciones digitales.',
      'Potenciamos la experiencia educativa de los estudiantes.',
      'Optimización de procesos internos de la empresa.',
    ],
    icon: '',
    bg: '/img/areas/tic.webp',
    bgAlt: 'Desarrollo de software educativo',
  },
  {
    title: 'Comercial',
    summary: 'Crecimiento de nuevos clientes mediante venta efectiva a instituciones y familias apasionadas por la tecnología.',
    details: [
      'Venta efectiva de productos y servicios.',
      'Enfoque en instituciones y familias afines a la tecnología.',
      'Impulso del crecimiento de clientes.',
    ],
    icon: '',
    bg: '/img/areas/comercial.webp',
    bgAlt: 'Asesoría comercial a familias e instituciones',
  },
  {
    title: 'Prácticas preprofesionales',
    summary: 'Integra equipos reales, participa en proyectos y recibe el acompañamiento necesario para crecer profesionalmente.',
    details: [
      'Expande tu experiencia.',
      'Integración a equipos reales.',
      'Proyectos con acompañamiento.',
      'Crecimiento profesional.',
    ],
    icon: '',
    bg: '/img/areas/practicas.webp',
    bgAlt: 'Estudiantes en prácticas preprofesionales',
  },
];
const Landing = () => (
  <div className="landing-container">
    {/* Hero Banner */}
<section
  className="hero-section"
  aria-label="Equipo de trabajo en laboratorio de robótica"
  style={{
    backgroundImage: 'url(/img/hero/landing-hero.webp)',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }}
>
  <div className="hero-overlay" />
  <div className="hero-content">
    <h1>¡Únete a nuestro equipo!</h1>
    <p>Estamos buscando talentos como tú para seguir creciendo juntos</p>
    <Link to="/trabaja-con-nosotros" className="cta-button">
      Trabaja con nosotros
    </Link>
  </div>
</section>


    {/* Información de la empresa */}
    <section className="empresa-info">
      <h2>Sobre Nuestra Empresa</h2>
      <div className="empresa-content">
<div className="empresa-texto">
            <p>
              Nuestros valores la determinación, disrupción, resultados e innovación se ve reflejado a cada idea nueva y solución que creamos. Buscamos personas apasionadas por la tecnología, que compartan estos valores y quieran trascender, haciendo que las cosas pasen.
            </p>
          </div>
<div className="empresa-video">
  <div className="video-wrapper">
    <iframe
      src="https://www.youtube-nocookie.com/embed/TzPOm4d0tO4?si=-PWnPCGIXDKQatBO&amp;start=1"
      title="Conócenos"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerPolicy="strict-origin-when-cross-origin"
      allowFullScreen
      loading="lazy"
    />
  </div>
</div>

      </div>
    </section>

    {/* Áreas de interés */}
    <section className="areas-interes">
      <h2>Áreas de Interés</h2>
      <div className="areas-grid">
        {areas.map((area) => (
          <AreaCard key={area.title} {...area} />
        ))}
      </div>
    </section>

    {/* CTA */}
    <section className="cta-section">
      <h2>¿Listo para dar el siguiente paso en tu carrera?</h2>
      <p>Completa nuestro formulario y forma parte de nuestro equipo</p>
      <Link to="/trabaja-con-nosotros" className="cta-button">
        Trabaja con nosotros
      </Link>
    </section>
  </div>
);

export default Landing;
